import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select';
import { PAGE_SIZE_OPTIONS } from '@/shared/types/pagination';

interface PaginationSizeSelectorProps {
  pageSize: number;
  pageSizeOptions?: number[];
  onChangePageSize: (size: number) => void;
}

export function PaginationSizeSelector({
  pageSize,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
  onChangePageSize,
}: PaginationSizeSelectorProps) {
  const { t } = useTranslation('pagination');

  return (
    <div className="flex items-center gap-2">
      <span className="hidden sm:block text-sm text-muted-foreground whitespace-nowrap">
        {t('rowsPerPage')}
      </span>
      <Select value={String(pageSize)} onValueChange={(val) => onChangePageSize(Number(val))}>
        <SelectTrigger className="h-8 w-[72px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {pageSizeOptions.map((size) => (
            <SelectItem key={size} value={String(size)}>
              {size}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
